<template>
  <page>
    <template slot="title">Энергоснабжение</template>
    <template slot="section">
      <columns>
        <column size="10">
          <p><b>Энергоснабжение с ОРЭМ</b></p>
          <p>Согласно действующему законодательству, крупные промышленные потребители имеют возможность снизить размер сбытовой надбавки путем покупки электроэнергии с оптового рынка (ОРЭМ). Такую возможность получают потребители, соответствующие критериям рынка и выполнившие необходимые условия для допуска к торговой системе. В случае покупки с ОРЭМ электроэнергия приобретается «напрямую», минуя региональную энергосбытовую компанию. При этом размер сбытовой надбавки на 1 кВт.ч. устанавливается индивидуально в зависимости от параметров конкретного потребителя и является договорной величиной, всегда существенно меньшей, чем у Гарантирующего поставщика. </p>
          <p>Наша Компания готова осуществить вывод крупных промышленных потребителей и групп компаний на ОРЭМ. Указанная процедура включает два этапа:</p>
          <p>создание автоматизированной системы коммерческого учета электроэнергии (АИИС КУЭ), аттестация системы в коммерческом операторе рынка с присвоением класса качества, соответствующего требованиям ОРЭМ, регистрация группы точек поставки на оптовом рынке;<br/>осуществление торговых операций (покупки электроэнергии и мощности) на оптовом рынке, обеспечивающих необходимую экономию затрат на энергоресурсы.</p>
          <p>Являясь квалифицированным участником рынка, мы готовы рассчитать для Вас возможный экономический эффект от работы на ОРЭМ и (в случае Вашей заинтересованности) комплексно сопроводить процедуру с последующей поставкой электроэнергии (заключением договора энергоснабжения).</p>
          <p><b>Энергоснабжение с РРЭ</b></p>
          <p>Имея положительный опыт работы и долгосрочные партнерские отношения с поставщиками электроэнергии на розничном рынке, наша Компания обладает всем необходимым набором инструментов для оптимизации стоимости энергоресурсов.</p>
          <p>Мы готовы предложить Вам наименьшую цену на электроэнергию, надежность и удобный график платежей. Поставка с розничного рынка предполагает:</p>
          <p>­короткие сроки заключения договора;<br/>­отсутствие затрат при переходе в независимую энергосбытовую компанию;<br/>­комплексное сопровождение;<br/>­предоставление персонального менеджера, готового ответить на все интересующие вопросы в любое удобное для Вас время.</p>
          <line-break size="m"/>
          <!--<doc title="Опросный лист энергоснабжения" url=""/>-->
        </column>
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-09.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import LineBreak from '@/components/LineBreak';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Page,
    LineBreak,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
    }
  }
}
</script>



// WEBPACK FOOTER //
// Power.vue?2b5e3384